interface UserAvatarProps {
  readonly username: string | null
  readonly avatarUrl?: string | null
  readonly size?: 'sm' | 'md'
}

const SIZES = {
  sm: 'w-9 h-9 text-xs',
  md: 'w-11 h-11 text-sm',
} as const

/**
 * Vignette d'un utilisateur. À défaut d'avatar, l'initiale du pseudo suffit à
 * distinguer les lignes d'une liste sans charger d'image.
 */
export function UserAvatar({ username, avatarUrl, size = 'md' }: UserAvatarProps) {
  const initial = (username ?? '?').charAt(0).toUpperCase()

  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt=""
        aria-hidden="true"
        className={`${SIZES[size]} shrink-0 rounded-full object-cover`}
      />
    )
  }

  return (
    <span
      aria-hidden="true"
      className={`${SIZES[size]} flex shrink-0 items-center justify-center rounded-full bg-primary font-bold leading-none text-white`}
    >
      {initial}
    </span>
  )
}
